<template>
  <div>
    <!-- delete confirmation modal -->
    <v-dialog v-model="modal" max-width="500px">
      <v-card>
        <v-card-title>Confirmation Required</v-card-title>
        <v-card-text>
          Are you sure want to delete ssh key '{{ removingUserSSHKey.name }}'?
        </v-card-text>
        <v-card-actions>
          <v-btn text v-on:click.native="modal = false" class="primary"
            >Cancel</v-btn
          >
          <v-spacer> </v-spacer>
          <v-btn
            v-on:click.native="deleteUserSSHKey(removingUserSSHKey)"
            text
            class="primary--text"
          >
            Delete
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-layout class="mt-2">
      <div class="tbcard">
        <v-card outlined>
          <v-card-title>
            <v-icon class="mr-2">mdi-console</v-icon>
            SSH Access
            <v-spacer></v-spacer>
            <v-tooltip left>
              <template v-slot:activator="{ on: tooltip }">
                <v-btn
                  icon
                  v-on="tooltip"
                  href="https://docs.synpse.net/synpse-core/devices/ssh"
                  target="_blank"
                  rel="noopener"
                >
                  <v-icon color="grey" small>help</v-icon>
                </v-btn>
              </template>
              <span
                >SSH keys allow accessing devices managed by Synpse directly
                from any client.</span
              >
            </v-tooltip>
          </v-card-title>
          <v-card-text>
            <v-data-table
              :key="tableKey"
              :headers="headers"
              :items="userSSHKeys"
              :search="e3"
              dense
            >
              <template v-slot:top>
                <v-layout>
                  <p class="grey--text">
                    Upload your own SSH keys to allow access to Synpse managed
                    devices from any client that can make SSH connections
                    (Ansible, Terraform, etc.)
                  </p>
                  <v-spacer></v-spacer>
                  <create-user-SSH-key></create-user-SSH-key>
                </v-layout>
              </template>

              <template v-slot:[`item.name`]="{ item }">
                {{ item.name }}
              </template>

              <template v-slot:[`item.key`]="{ item }">
                <v-tooltip top :key="item.name">
                  <template v-slot:activator="{ on: tooltip }">
                    <span v-on="{ ...tooltip }">
                      {{ item.key && item.key.substring(0, 30) + "...." }}
                    </span>
                  </template>
                  <span>{{ item.key }}</span>
                </v-tooltip>
              </template>

              <template v-slot:[`item.createdAt`]="{ item }">
                <v-tooltip top :key="item.name">
                  <template v-slot:activator="{ on: tooltip }">
                    <span v-on="{ ...tooltip }">
                      {{ item.createdAt | ago }}
                    </span>
                  </template>
                  <span>{{ item.createdAt | date }}</span>
                </v-tooltip>
              </template>

              <template v-slot:[`item.lastTimeUsed`]="{ item }">
                <v-tooltip top :key="item.name">
                  <template v-slot:activator="{ on: tooltip }">
                    <span v-on="{ ...tooltip }">
                      {{ item.lastTimeUsed | ago }}
                    </span>
                  </template>
                  <span>{{ item.lastTimeUsed | date }}</span>
                </v-tooltip>
              </template>

              <template v-slot:[`item.actions`]="{ item }">
                <v-menu
                  class="items"
                  top
                  left
                  transition="v-slide-y-transition"
                >
                  <template v-slot:activator="{ on: on }">
                    <v-btn
                      icon
                      v-on="on"
                      :class="
                        $store.state.theme === 'light' ? 'secondary--text' : ''
                      "
                    >
                      <v-icon>more_vert</v-icon>
                    </v-btn>
                  </template>

                  <v-list dense>
                    <v-list-item @click="removeUserSSHKeyIntent(item)">
                      <v-list-item-title>delete</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </div>
    </v-layout>
  </div>
</template>

<style lang="stylus">
.tbcard {
  width: 100%;
  display: block;
}
</style>

<script>
// import PageSubtitle from '../PageSubtitle';
import CreateUserSSHKey from './CreateUserSSHKey.vue';

export default {
  components: {
    // PageSubtitle,
    CreateUserSSHKey,
  },
  data() {
    return {
      tableKey: '',
      e3: null,
      headers: [
        { text: 'Name', align: 'left', value: 'name', sortable: true },
        { text: 'Key', value: 'key', align: 'left' },
        { text: 'Created', value: 'createdAt', align: 'left' },
        { text: 'Last used', value: 'lastTimeUsed', align: 'left' },
        { text: '', value: 'actions', sortable: false, align: 'right' }
      ],
      modal: false,
      removingUserSSHKey: {
        id: '',
        name: ''
      }
    }
  },

  computed: {
    loading() {
      return this.$store.state.iam.loading
    },
    userSSHKeys() {
      return this.$store.state.iam.userSSHKeys
    },
  },

  mounted() {
    this.refresh()
  },

  methods: {
    refresh() {
      this.$store.dispatch('ListUserSSHKeys')
    },
    removeUserSSHKeyIntent(removingUserSSHKey) {
      // assigning removing input val
      this.removingUserSSHKey = removingUserSSHKey
      this.modal = true
    },
    deleteUserSSHKey() {
      this.$store.dispatch('DeleteUserSSHKey', this.removingUserSSHKey).then(() => {
        this.refresh()
        // closing confirmation modal
        this.modal = false
      })
    }
  }
}
</script>
